import { GetCurrentUserPermissionsResponse } from 'services/users';
import { ResourceTypes } from 'types/permissions';

// NOTE: This is intentionally a pure utility (no React hooks) that lives in hooks/
// because it's consumed alongside SPM navigation hooks.
export type CanViewCollaboratorResourceParams = {
  isCollaborationUser: boolean;
  userPermissions: GetCurrentUserPermissionsResponse | undefined;
  planningCycleId: string | undefined;
  activeScenarioId: string | undefined;
  isPermissionsV2Enabled: boolean;
  modelId: string;
  modelType: ResourceTypes;
};

export function canViewCollaboratorResource({
  isCollaborationUser,
  userPermissions,
  planningCycleId,
  activeScenarioId,
  isPermissionsV2Enabled,
  modelId,
  modelType,
}: CanViewCollaboratorResourceParams): boolean {
  if (!isCollaborationUser) {
    return true;
  }

  if (!userPermissions?.shared_resources) {
    return false;
  }

  const { shared_resources: sharedResources } = userPermissions;
  const hasV2SharedViewOnPlan =
    !!planningCycleId &&
    sharedResources.some((sr) => sr.resource_type === 'spm_shared_view' && sr.resource_path[0] === planningCycleId);
  const shouldUseV2Flow = isPermissionsV2Enabled && hasV2SharedViewOnPlan;

  return sharedResources.some((sharedResource) => {
    if (modelType === 'spm_model') {
      if (shouldUseV2Flow && sharedResource.resource_type === 'spm_shared_view') {
        const path = sharedResource.resource_path;
        if (path.length < 3 || path[2] !== modelId) {
          return false;
        }
        if (activeScenarioId && path[1] !== activeScenarioId) {
          return false;
        }
        return true;
      }
      if (shouldUseV2Flow) {
        return false;
      }
      if (sharedResource.resource_type === modelType) {
        return sharedResource.resource_path.length >= 2 && sharedResource.resource_path[1] === modelId;
      }
      if (sharedResource.resource_type === 'spm_shared_view') {
        return sharedResource.resource_path.length >= 3 && sharedResource.resource_path[2] === modelId;
      }
      return false;
    }
    return sharedResource.resource_path.includes(modelId) && sharedResource.resource_type === modelType;
  });
}
